import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { Tooltip } from '@jutro/components';
import { useTranslator } from '@jutro/locale';
import { platformMessages } from 'ml-components-platform-react';
import { ViewModelForm, useDataRefresh } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import appConfig from 'app-config';
import metadata from './PeriodStartDateComponent.metadata.json5';
import messages from './PeriodStartDateComponent.messages';
import styles from './PeriodStartDateComponent.module.scss';

function productSelectionTooltipTemplate(translator) {
    return (
        <div>
            <span>
                {translator(messages.periodStartDateTooltipContent)}
            </span>
            <br />
            <br />
            <span>
                {translator(messages.periodStartDateTooltipContentParagraph2)}
            </span>
        </div>
    );
}

function PeriodStartDateTooltipComponent() {
    const translator = useTranslator();

    return (
        <Tooltip
            id="tooltip"
            placement="bottom"
            trigger="click"
            content={productSelectionTooltipTemplate(translator)}
            className={styles.dateTooltipContainerStyle}
        >
            <span className={styles.dateSelectiontooltipOverride}>
                {translator(platformMessages.mlWhatDoesItMean)}
            </span>
        </Tooltip>
    );
}

function PeriodStartDatePopup(props) {
    const {
        submissionVM, id, onSave, onCancel
    } = props;
    const { onValidate: setComponentValidation, isComponentValid } = useValidation(id);
    const isQnB = appConfig.portalCode === 'QB';
    const { refreshData } = useDataRefresh();

    const onSaveDetails = async () => {
        if (onSave) {
            onSave();
        }
    };

    const resolvers = {
        resolveComponentMap: {
            periodStartDateTooltipComponent: PeriodStartDateTooltipComponent
        },
        resolveClassNameMap: styles,
        resolveCallbackMap: {
            onSaveDetails: onSaveDetails,
            onCancel: onCancel
        }
    };

    const writeValue = (value, path) => {
        _.set(submissionVM.value, path, value);
        _.set(submissionVM, path, value);
        refreshData();
    };

    const overrides = {
        nextButton: {
            disabled: !isComponentValid,
            className: isQnB ? "submitButtonQB primaryButton" : "submitButtonQB"
        },
        cancelButton: {
            className: isQnB ? "ml-btn submitCancelButton secondaryButton widthSmall" : "ml-btn submitCancelButton"
        }
    };

    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
            model={submissionVM}
            onValueChange={writeValue}
            onValidationChange={setComponentValidation}
            showErrors
            overrideProps={overrides}
            callbackMap={resolvers.resolveCallbackMap}
        />
    );
}

PeriodStartDatePopup.propTypes = {
    model: PropTypes.shape({}).isRequired,
    onSave: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired
};
export default PeriodStartDatePopup;
